<template>
  <div class="event-cinema-form"
    v-bind:class="{ 'show': !this.isOrderCompleted && isActive, 'animate__animated animate__fadeOutRight': this.isOrderCompleted && isActive }">
    <div class="form-title"> Ваш заказ </div>
    <div class="form-details-wrapper">
      <div class="event-title"> {{ payload.event.name }} </div>
      <div class="event-date"> {{ getDateStart.format('DD MMM yyyy в HH:mm') }} </div>
      <div class="event-price"> Кол-во мест : {{ getCount }} </div>
      <div class="event-price"> Итого : <b>{{ getPrice }}</b> ₾ </div>
    </div>
    <div class="input-wrapper">
      <IconInput label="Ваше имя *" placeholder="John" type="text" v-model="username">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M16.6666 17.5V15.8333C16.6666 14.9493 16.3155 14.1014 15.6903 13.4763C15.0652 12.8512 14.2174 12.5 13.3333 12.5H6.66665C5.78259 12.5 4.93474 12.8512 4.30962 13.4763C3.6845 14.1014 3.33331 14.9493 3.33331 15.8333V17.5M13.3333 5.83333C13.3333 7.67428 11.8409 9.16667 9.99998 9.16667C8.15903 9.16667 6.66665 7.67428 6.66665 5.83333C6.66665 3.99238 8.15903 2.5 9.99998 2.5C11.8409 2.5 13.3333 3.99238 13.3333 5.83333Z"
            stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </IconInput>
      <IconInput label="Ваша почта *" placeholder="you@mail" type="mail" v-model="mail">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M18.3334 4.99992C18.3334 4.08325 17.5834 3.33325 16.6667 3.33325H3.33335C2.41669 3.33325 1.66669 4.08325 1.66669 4.99992M18.3334 4.99992V14.9999C18.3334 15.9166 17.5834 16.6666 16.6667 16.6666H3.33335C2.41669 16.6666 1.66669 15.9166 1.66669 14.9999V4.99992M18.3334 4.99992L10 10.8333L1.66669 4.99992"
            stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </IconInput>
      <div class="button-wrapper">
        <custom-button button-text="Отмена" button-type="reset" :isBlocked="false" @clicked="closeForm" />
        <custom-button button-text="Подтвердить" button-type="apply" :isBlocked="!(isUsernameValid && isMailValid)"
          @clicked="completeForm" />
      </div>
    </div>
  </div>
</template>

<script>

  import IconInput from '../Inputs/IconInput.vue'
  import CustomButton from '../Inputs/CustomButton.vue'
  import moment from 'moment/moment'
  import apiClient from "../../../apiClient";

  export default {
    name: 'EventCinemaForm',
    components: { CustomButton, IconInput },
    props: ['event', 'isActive', 'payload'],
    data() {
      return {
        isOrderCompleted: false,
        username: '',
        mail: ''
      }
    },
    computed: {
      isMailValid() {
        return (/.+?\@.+/g).test(this.mail) && this.mail.length > 2
      },
      isUsernameValid() {
        return this.username.length >= 2
      },
      getDateStart() {
        return moment(this.payload.event.startDate, 'YYYY-MM-DD HH:mm')
      },
      getPrice() {
        let allSeats = this.payload.event.seatList

        return allSeats.filter(
          (seat) => seat.seatType === 'LOW' && this.$store.state.selectedSeatSet.has(seat.id)
        ).length * this.payload.event.lowPrice + allSeats.filter(
          (seat) => seat.seatType === 'STANDART' && this.$store.state.selectedSeatSet.has(seat.id)
        ).length * this.payload.event.standartPrice + allSeats.filter(
          (seat) => seat.seatType === 'PREMIUM' && this.$store.state.selectedSeatSet.has(seat.id)
        ).length * this.payload.event.premiumPrice
      },
      getCount() {
        return this.$store.state.selectedSeatSet.size
      }
    },
    methods: {
      completeForm() {
        let data = {
          orderType: 'EVENT_HALL',
          order: {
            eventId: this.payload.event.id,
            seatIdList: this.$store.state.selectedSeatSet,
            mail: this.mail
          }
        }
        apiClient.post('/api/order', data)
        this.isOrderCompleted = true
        this.$emit('completed', this.mail)
      },
      closeForm() {
        this.$emit('closed')
      }
    }
  }

</script>

<style scoped>
.event-cinema-form {
  padding: 24px;
  width: fit-content;
  display: none;
  flex-direction: column;
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);
}

.event-cinema-form.show {
  display: flex;
}

.form-title {
  color: #101828;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-bottom: 8px;
}

.form-details-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.event-title {
  color: #101828;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.event-date {
  color: #101828;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.event-price {
  color: #101828;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  gap: 12px;
}

.button-wrapper {
  padding-top: 20px;
  display: flex;
  gap: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/Forms/EventCinemaForm.vue